// import React, { useContext, useEffect, useState } from "react";
// import css from "../css/Mywallet.module.css";
// import Rightcontainer from "../Components/Rightcontainer";
// import { Link, useHistory } from "react-router-dom";
// import axios from "axios";
// import socket from "../Components/socket";
// import { AiOutlineHistory, AiOutlinePlus } from "react-icons/ai";
// import { BsWallet2 } from "react-icons/bs";
// import io from "../Components/socket";
// import { LanguageContext } from "../Components/LanguageContext";
// import { useTheme } from "../../ThemeContext";
// import { VscReferences } from "react-icons/vsc";

// const Mywallet = ({ user }) => {
//   // const [user, setUser] = useState();

//   const access_token = localStorage.getItem("token");
//   //   const walletUpdate =()=>{
//   //  io.emit("getprofile", access_token);
//   //   io.on("setProfile", (data) => {
//   //     setUser(data);
//   //   });
//   //   }

//   //   useEffect(()=>{
//   //     walletUpdate()
//   //   },[]);

//   // language
//   const translations = {
//     hi: {
//       wallet: "वॉलेट",
//       history: "इतिहास देखे | ",
//       amount: "पैसे जोड़ें | ",
//       withdraw: "पैसे निकाले  | ",
//       referPerson: "रेफ़रल | ",
//     },
//     en: {
//       wallet: "My Wallet",
//       history: "Order History",
//       amount: "Add Cash",
//       withdraw: "Withdraw",
//       referPerson: "Referral",
//     },
//   };

//   const { language } = useContext(LanguageContext);

//   // change theme
//   const theme = localStorage.getItem("theme");

//   const styles = {
//     backgroundColor: theme === "light" ? "#d3e3fd" : "#000",
//     color: theme === "light" ? "black" : "#fff",
//   };

//   return (
//     <>
//       <div
//         className="leftContainer mb_space"
//         style={{ ...styles, height: "100vh" }}
//       >
//         <div className="balance-section pt-2 mt-5 Orher_page_main_section">
//           <div className="mt-2">
//             <h3 className="mb-3">Balance</h3>

//             {/* Deposit Cash Card */}
//             <div className="unique-card">
//               <div className="unique-card-left">
//                 <img src="/images/deposit.png" className="card-main-img" />
//               </div>

//               <div className="unique-card-right">
//                 <h2 className="uc-title">Deposit Cash</h2>

//                 <div className="uc-amount">
//                   <img src="/images/rupee.png" className="rupee-icon" />
//                   <b>{user && user.Wallet_balance - user.withdrawAmount}</b>
//                 </div>

//                 <Link to="/addcase">
//                   <button className="uc-btn">
//                     <AiOutlinePlus className="icons" />{" "}
//                     {translations[language].amount}
//                   </button>
//                 </Link>
//               </div>
//             </div>

//             {/* Winning Cash Card */}
//             <div className="unique-card win">
//               <div className="unique-card-left">
//                 <img
//                   src="/images/win-cash.png"
//                   className="card-main-img"
//                   style={{ transform: "scale(1.5)" }}
//                 />
//               </div>

//               <div className="unique-card-right">
//                 <h2 className="uc-title">Winning Cash</h2>

//                 <div className="uc-amount text-danger">
//                   <img src="/images/rupee.png" className="rupee-icon" />
//                   <b>{user && user.withdrawAmount}</b>
//                 </div>

//                 <Link to="/Withdrawopt">
//                   <button className="uc-btn withdraw">
//                     <BsWallet2 className="icons" />{" "}
//                     {translations[language].withdraw}
//                   </button>
//                 </Link>
//               </div>
//             </div>
//           </div>
//         </div>

//         <div className="rightContainer">
//           <div>
//             <Rightcontainer />
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };
// export default Mywallet;

import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { LanguageContext } from "../Components/LanguageContext";
import {
  MdDownload,
  MdUpload,
  MdAccountBalanceWallet,
  MdAdd,
  MdArrowForward,
  MdVerified,
  MdSecurity,
  MdPayments,
  MdArrowDownward
} from "react-icons/md";

const Mywallet = ({ user }) => {

  const { language } = useContext(LanguageContext);

  const translations = {
    hi: {
      status: "खाता स्थिति",
      verified: "सत्यापन पूरा हुआ",
      deposit: "डिपॉजिट चिप्स",
      winnings: "विनिंग चिप्स",
      availablePlay: "खेलने के लिए उपलब्ध",
      withdrawBal: "निकालने योग्य शेष",
      add: "Add Chips",
      withdraw: "Withdraw",
      secure: "आपके ट्रांजैक्शन 100% सुरक्षित और एन्क्रिप्टेड हैं।",
    },

    en: {
      status: "Account Status",
      verified: "Verification Completed",
      deposit: "Deposit Chips",
      winnings: "Winning Chips",
      availablePlay: "Available for play",
      withdrawBal: "Withdrawable balance",
      add: "Add Chips",
      withdraw: "Withdraw",
      secure: "Your transactions are 100% secure and encrypted.",
    },
  };

  const t = translations[language] || translations.en;

  const depositAmount = user
    ? (user.Wallet_balance - user.withdrawAmount).toFixed(2)
    : "0.00";

  const winningAmount = user
    ? user.withdrawAmount.toFixed(2)
    : "0.00";

  const totalBalance =
    Number(depositAmount) + Number(winningAmount);


  return (
    <div className="prince_wallet_page">

      <div className="prince_wallet_main">

        {/* =========================================
        WALLET CARD
    ========================================= */}

        <section className="prince_wallet_card">

          {/* Decorative glow */}
          <div className="prince_wallet_glow prince_wallet_glow_one"></div>
          <div className="prince_wallet_glow prince_wallet_glow_two"></div>

          {/* Top section */}

          <div className="prince_wallet_card_top">

            <div className="prince_wallet_balance_info">

              <span className="prince_wallet_balance_label">
                Total Balance
              </span>

              <strong className="prince_wallet_balance_value">
                ₹{totalBalance.toFixed(2)}
              </strong>

            </div>


            {/* Wallet illustration */}

            <div className="prince_wallet_visual">
              <img src="../images/deposit-wallet.png" className="img-fluid" />


            </div>

          </div>


          {/* Balance mini rows */}

          <div className="prince_wallet_balance_rows">

            {/* Play Money */}

            <div className="prince_wallet_balance_row">

              <div className="prince_wallet_row_left">

                <span className="prince_wallet_row_icon prince_play_icon">
                  ★
                </span>

                <span>
                  Play money
                </span>

              </div>

              <strong>
                ₹{depositAmount}
              </strong>

            </div>


            {/* Winnings */}

            <div className="prince_wallet_balance_row">

              <div className="prince_wallet_row_left">

                <span className="prince_wallet_row_icon prince_win_icon">
                  ♛
                </span>

                <span>
                  Winnings
                </span>

              </div>

              <strong>
                ₹{winningAmount}
              </strong>

            </div>

          </div>

        </section>


        {/* =========================================
        WALLET ACTIONS
    ========================================= */}

        <section className="prince_wallet_actions">

          {/* ADD CASH */}

          <Link
            to="/addcase"
            className="prince_wallet_action prince_add_action"
          >

            <div className="prince_wallet_action_icon">
              <MdPayments />
            </div>

            <div className="prince_wallet_action_text">

              <strong>
                Add Cash
              </strong>

              <span>
                Add money to wallet
              </span>

            </div>

            <div className="prince_wallet_action_arrow">
              <MdArrowForward />
            </div>

          </Link>


          {/* WITHDRAW */}

          <Link
            to="/Withdrawopt"
            className="prince_wallet_action prince_withdraw_action"
          >

            <div className="prince_wallet_action_icon">
              <MdArrowDownward />
            </div>

            <div className="prince_wallet_action_text">

              <strong>
                Withdraw
              </strong>

              <span>
                Withdraw winnings
              </span>

            </div>

            <div className="prince_wallet_action_arrow">
              <MdArrowForward />
            </div>

          </Link>

        </section>


        {/* =========================================
        SECURITY
    ========================================= */}

        <div className="prince_wallet_secure">

          <MdSecurity />

          <span>
            {t.secure}
          </span>

          <MdVerified />

        </div>


      </div>

    </div>
  );
};

export default Mywallet;